import { render, staticRenderFns } from "./discontinuedTimeoutList.vue?vue&type=template&id=a710c7c6"
import script from "./discontinuedTimeoutList.vue?vue&type=script&lang=js"
export * from "./discontinuedTimeoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports